import React from 'react';
import { scrollToOffer } from '../utils/scroll';
export function HeroSection() {
  return <section className="pt-24 pb-12 px-4 bg-gradient-to-b from-blue-50 to-white overflow-hidden" data-id="element-74">
      <div className="max-w-4xl mx-auto text-center" data-id="element-75">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-blue-900 mb-6 leading-tight" data-id="element-76">
          Mega-Pack Yoga e Mindfulness per Bambini
        </h1>

        <p className="text-xl md:text-2xl font-medium text-gray-800 mb-6" data-id="element-77">
          Il sistema completo per insegnare calma, movimento e consapevolezza ai
          bambini in modo semplice e divertente.
        </p>

        <p className="text-lg text-gray-600 mb-4 max-w-3xl mx-auto" data-id="element-78">
          Una raccolta di materiali pratici con posizioni yoga, giochi di
          movimento, esercizi di respirazione e attività di mindfulness pensati
          per genitori, insegnanti ed educatori.
        </p>

        <p className="text-lg text-gray-600 mb-12 max-w-3xl mx-auto font-medium" data-id="element-79">
          Tutto organizzato passo dopo passo e pronto all'uso, anche se non hai
          esperienza con lo yoga.
        </p>

        {/* Fanned Images */}
        <div className="relative w-full max-w-3xl mx-auto h-64 md:h-96 mb-12 flex justify-center items-center mt-8" data-id="element-80">
          <img src="https://cdn.magicpatterns.com/uploads/gsVEyfjnzcuvgW4HC3rG6m/Tomo_4.png" alt="Carte e Poster" className="absolute z-0 w-1/4 -translate-x-3/4 translate-y-8 -rotate-12 shadow-xl rounded-lg border border-gray-200" data-id="element-81" />
          <img src="https://cdn.magicpatterns.com/uploads/f4Zd95gcYtK15ny8x2VRuN/Tomo_2.png" alt="Giochi e Attività" className="absolute z-10 w-1/4 -translate-x-1/3 translate-y-4 -rotate-6 shadow-2xl rounded-lg border border-gray-200" data-id="element-82" />
          <img src="https://cdn.magicpatterns.com/uploads/1GeMRcLpmUHx4qsugtEApX/Tomo_5.png" alt="Yoga per Famiglia e Scuola" className="absolute z-10 w-1/4 translate-x-1/3 translate-y-4 rotate-6 shadow-2xl rounded-lg border border-gray-200" data-id="element-83" />
          <img src="https://cdn.magicpatterns.com/uploads/crX2ptMyf6Ln3wgTVHvb6J/Tomo_3.png" alt="Diario di Mindfulness" className="absolute z-0 w-1/4 translate-x-3/4 translate-y-8 rotate-12 shadow-xl rounded-lg border border-gray-200" data-id="element-84" />
          <img src="https://cdn.magicpatterns.com/uploads/tjgkzNkd3KeZC2JTS9FMDA/Tomo_1.png" alt="Manuale di Yoga per Bambini" className="absolute z-20 w-1/3 scale-110 shadow-2xl rounded-lg border border-gray-200" data-id="element-85" />
        </div>

        <button onClick={scrollToOffer} className="bg-green-600 hover:bg-green-700 text-white font-bold text-xl py-5 px-10 rounded-full shadow-xl hover:shadow-2xl transition-all transform hover:-translate-y-1 animate-pulse w-full md:w-auto" data-id="element-86">
          SCOPRI L'OFFERTA SPECIALE
        </button>
      </div>
    </section>;
}